/** Resolves false instead of rejecting when the write is denied, so callers can surface the failure. */
export const copyTextToClipboard = (text: string): Promise<boolean> => {
    return navigator.clipboard
        .writeText(text)
        .then(() => true)
        .catch(() => false);
};
